module.exports = __webpack_public_path__ + "assets/svg/Icons/32/cog-gray-837826.svg";